import { useSelector } from 'react-redux'
import { getMobileQrReceiptDialog } from '../../Selectors'
import styles from './VNMobileQRReceiptDialog.module.scss'
import { APPLICATION_STRINGS } from '../../../strings'
import VNConcessionsNavBar from '../../../components/VNConcessionsNavBar'
import { ReactComponent as CloseIcon } from '../../../assets/closeMobile.svg'
import { ReactComponent as BackIcon } from '../../../assets/icons/back-chevron.svg'
import QRCode from '../../../components/QRCode'
import { centsToDollars } from '../../../utils/formatters'

/**
 * General info dialog with customizable icon, title, message, and confirm action
 *
 */
export const VNMobileQRReceiptDialog = () => {
  const props = useSelector(getMobileQrReceiptDialog)

  if (!props?.open) {
    return null
  }

  return (
    <div className={styles.root}>
      <VNConcessionsNavBar
        showIcon={true}
        useHamburgerIcon={false}
        leftAccessory={<BackIcon onClick={props?.onBack} />}
        rightAccessory={<CloseIcon onClick={props?.onClose} />}
      />

      <div className={styles.totalContainer}>
        <div className={styles.qrTitle}>{APPLICATION_STRINGS.QR_TOTAL}</div>
        <div className={styles.qrAmount}>{centsToDollars(props?.total)}</div>
      </div>

      <div className={styles.qrContainer}>
        <div className={styles.qrScanVerbiage}>{APPLICATION_STRINGS.SCAN_DIGITAL_RECEIPT}</div>
        <div className={styles.qrcode}>
          <QRCode size={170} data={props?.qrCode}/>
        </div>
      </div>
    </div>
  )
}
